import { render } from "./NavbarComponent.vue?vue&type=template&id=72764510&ts=true"
import script from "./NavbarComponent.vue?vue&type=script&lang=ts"
export * from "./NavbarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__